import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectAllManagementTokens } from './management.reducer';
import { ManagementState, ManagementToken, ManagementTokens, selectExpirationDate } from './management.state';

export const selectManagementState = createFeatureSelector<ManagementState>('management');

export const selectAllTokens = createSelector(selectManagementState, selectAllManagementTokens);

export const selectToken = <TTokenType extends keyof ManagementTokens>(tokenType: TTokenType) =>
  createSelector(selectManagementState, (state) => {
    return state.entities[tokenType] as ManagementToken<TTokenType> | undefined;
  });

export const selectAllTokensOrderedByExpirationDate = createSelector(selectAllTokens, (tokens) =>
  tokens.sort((a, b) => selectExpirationDate(a).getTime() - selectExpirationDate(b).getTime())
);
